let instance;

const STICKY_MENU_OFFSET = -74;

export default async function asyncSweetScroll(target, offset = 0) {
  const { default: SweetScroll } = await import(
    /* webpackChunkName: "sweet-scroll" */ 'sweet-scroll'
  );

  if (!instance) {
    instance = new SweetScroll();
  }
  const node = typeof target === 'string' ? document.querySelector(target) : target?.[0] ?? target;

  instance.toElement(
    node,
    {
      duration: 750,
      offset: offset || STICKY_MENU_OFFSET - 6
    }
  );
}
